import Manager, { getRoles } from './manager'
import { hasPermission as permission } from '@com/permission'

/**
 * 权限判断
 * @param {string|[string]} latchkey 权限 key 值
 * @param {string} [type] 当第一个参数是数组的时候，type 可选 or 或 and，默认 and
 * @param {array} [roles] 权限 key 列表
 */
export const hasPermission = (latchkey, type, roles) => {
  return permission(latchkey, type, roles || getRoles())
}

function install(Vue) {
  Vue.component('PermissionManager', Manager)

  // Mixin 本身太过于灵活，太依赖使用者，很容易出现问题，特别是做全局混入对象时，一定要非常慎重
  // 谨慎使用全局混入对象，因为会影响到每个单独创建的 Vue 实例 (包括第三方模板)
  Vue.mixin({
    methods: {
      hasPermission
    }
  })
}

export default {
  install
}
